/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const Slice = createSlice({
  name: 'createGroup',
  initialState: {},
  reducers: {
    // setDay: (state, action) => {
    //   state.days[action.payload.id] = action.payload.day;
    // },
  },
});

// export const { setDay } = Slice.actions;
export default Slice.reducer;
